import React from 'react';
import loadable from '@loadable/component';
import styled from 'styled-components';
import image from 'images/12thwedgewood.jpg';
const H1 = loadable(() => import('components/Atoms/H1'));
const P = loadable(() => import('components/Atoms/P'));

const StyledH1 = styled(H1)`
  && {
    height: unset;
    text-align: inherit;
  }
`;

const StyledDiv = styled.div`
  && {
    position: relative;
    top: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
    margin-top: 2px;
    padding: 4px;
    background-color: rgba(0, 0, 0, 0.3);
  }
`;

const StyledP = styled(P)`
  && {
    margin: 2px auto 0 auto;
    color: white;
    max-width: 280px;
  }
`;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  height: 100%;
  width: 100%;
  background-image: url(${image});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
`;

function Maintenance() {
  return (
    <Wrapper>
      <StyledDiv>
        <StyledH1> Fortress Under Maintenance </StyledH1>
        <StyledP>
          Fortress is undergoing routine maintenance, and will be back up
          shortly.
        </StyledP>
      </StyledDiv>
    </Wrapper>
  );
}

export default Maintenance;
